// utils/dates.ts
/**  Convert a Date to an ISO-8601 string in true UTC  */
// export const toUtcISOString = (d: Date): string => {
//   return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
//   //              ─────────────── keep the trailing “Z”
// };
// // Guarantees we ALWAYS interpret the backend value as UTC
// export const parseUtc = (ts: string | Date) => {
//   const iso =
//     ts instanceof Date ? ts.toISOString() : ts.replace(' ', 'T');  // <─ add this
//   const withZ = iso.endsWith('Z') ? iso : iso + 'Z';
//   return new Date(withZ);
// };

// // Consistent pretty print (adjust the options / locale once, reuse everywhere)
// export const fmtLocal = (
//   ts: string | Date,
//   opts?: Intl.DateTimeFormatOptions
// ) =>
//   parseUtc(ts).toLocaleString('en-AU', {
//     day: '2-digit',
//     month: 'short',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     ...opts,
//   });



// /** Convert an ISO/UTC timestamp coming from the API into the string
//  *  format <input type="datetime-local"> expects, e.g. 2025-06-25T14:26 */
// export const utcToInputValue = (ts: string | Date) =>
//   //  ✓ parse as UTC first …
//   toUtcISOString(parseUtc(ts))       // 2025-06-25T14:26:00.000  (no “Z”)
//     .slice(0, 16);                   // keep yyyy-MM-ddTHH:mm

// /** Convert the user-edited local value back to the *UTC* string
//  *  your backend expects. */
// export const inputValueToUtc = (localStr: string) =>
//   toUtcISOString(new Date(localStr));


/** Turn a *local* Date into an ISO string that represents UTC */
export const toUtcISOString = (d: Date): string =>
  new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString();

/** Parse anything you got from the API as UTC (string may lack “Z”) */
export const parseUtc = (ts: string | Date) => {
  const iso = ts instanceof Date ? ts.toISOString() : ts.replace(' ', 'T');
  return new Date(iso.endsWith('Z') ? iso : iso + 'Z');
};

/** Pretty print for ISO timestamps with offset, e.g. APScheduler */
export const fmtIsoWithOffset = (
  ts: string | Date,
  opts?: Intl.DateTimeFormatOptions
) =>
  new Date(ts).toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...opts,
  });
/** Consistent local-zone pretty print */
export const fmtLocal = (
  ts: string | Date,
  opts?: Intl.DateTimeFormatOptions
) =>
  parseUtc(ts).toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...opts,
  });

/** Backend → <input type="datetime-local"> */
export const utcToInputValue = (ts: string | Date): string => {
  const d = ts instanceof Date ? ts : new Date(ts);

  if (!(d instanceof Date) || isNaN(d.getTime())) {
    // If not a valid date (uninitialized, corrupted, or partial input), return empty string.
    return "";
  }

  return toUtcISOString(d).slice(0, 16); // “YYYY-MM-DDTHH:mm”
};

/** <input> (local) → UTC string **without** trailing “Z” */
export const inputValueToUtc = (localStr: string) =>
  toUtcISOString(new Date(localStr)).replace('Z', ''); // “YYYY-MM-DDTHH:mm:ss.SSS”

/** Convenience for “now” when creating new rows */
export const nowInputValue = () => utcToInputValue(new Date());


/** Parse a mapping / DB value that might already be a Date */
export const asUtcDate = (x: string | Date) =>
  x instanceof Date ? x : new Date(x);

/** Convert a Date to the naïve ISO string FastAPI expects ("YYYY-MM-DDTHH:mm:ss.SSS") */
export const toBackendISO = (d: Date) => d.toISOString().replace('Z', '');


/*  Convert a “HH:mm” coming FROM the DB (stored as UTC) into the local
    clock value your <input type="time"> wants.  */
/* export const utcTimeToInput = (utcHHmm: string) => {
  const [h, m] = utcHHmm.split(":").map(Number);
  const d = new Date(Date.UTC(1970, 0, 1, h, m));
  return d
    .toLocaleTimeString(undefined, {
      hour:   "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .slice(0, 5); // → "10:00"
};

export const inputTimeToUtc = (localHHmm: string) => {
  const [h, m] = localHHmm.split(":").map(Number);
  const local  = new Date();
  local.setHours(h, m, 0, 0);               // local “today at 10:00”
  return new Date(local.getTime() - local.getTimezoneOffset() * 60_000)
    .toISOString()
    .slice(11, 19);                         // → "00:00:00"-style UTC
}; */


/** DB (UTC “HH:mm[:ss]”) → value prop for <input type="time"> */
export const utcTimeToInput = (utc: string) => {
  const [h, m] = utc.split(":").map(Number);
  // build a *UTC* date, then format it in the browser’s locale
  const d = new Date(Date.UTC(1970, 0, 1, h, m));
  return d.toLocaleTimeString([], { hour12: false, hour: "2-digit", minute: "2-digit" });
};

/** <input type="time"> local “HH:mm” → UTC “HH:mm:ss” */
export const inputTimeToUtc = (hhmm: string) => {
  const [h, m] = hhmm.split(":").map(Number);
  // build the same wall clock on Jan-01-1970 *in local zone*
  const local = new Date(1970, 0, 1, h, m);
  // toISOString converts that to UTC; grab the “HH:mm:ss” part
  return local.toISOString().slice(11, 19);
};

/** UTC “HH:mm:ss” → Pretty local time (e.g., “1:30 PM” or “13:30”) */
export const utcTimeToLocalPretty = (
  utc: string,
  opts: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' }
): string => {
  const [h, m, s] = utc.split(":").map(Number);
  const d = new Date(Date.UTC(1970, 0, 1, h, m, s || 0));
  return d.toLocaleTimeString(undefined, opts);
};